<template>
  <div>
    <div v-loading="loading">
      <div class="d-flex pt_6 mt-2 mb-2" style="    align-items: center;">
        <div class="side-frame-success"></div>
        <div>
          <span style="font-size: 14px; color: #606266">
            {{ $l('title_month_sales') || '月销量预估' }}
          </span>
        </div>
      </div>
      <el-collapse v-model="activeNames">
        <div
          v-for="item in storeRegions"
          :key="item.amazonStoreRegion"
          class="mb-1"
        >
          <el-collapse-item :name="item.amazonStoreRegion">
            <template slot="title">
              <div
                style="width: 100%;display: flex;align-items: center;justify-content: space-between;"
              >
                {{ item.v_amazonStoreRegion }}
              </div>
            </template>
            <PredictTable
              ref="predictTable"
              class="mt-1"
              :amzFirstDemandCode="amzFirstDemandCode"
              :amazonStoreRegion="item.amazonStoreRegion"
              :disabled="disabled"
              highlightCurrentRow
            />
          </el-collapse-item>
        </div>
      </el-collapse>
      <div
        v-if="isEmpty"
        style="display: flex;align-items: center;justify-content: center;height: 400px;"
      >
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PredictTable from './predict-table'
export default {
  components: { PredictTable },
  props: {
    disabled: { type: Boolean, default: false },
    amzFirstDemandCode: { type: String, default: '' },
  },
  data() {
    return {
      regionFormData: {
        amazonStoreRegion: '',
      },
      activeNames: [],
      storeRegions: [],
      tmpData: {},
      loading: false,
      rules: {
        amazonStoreRegion: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    isEmpty() {
      return !this.storeRegions || this.storeRegions.length < 1
    },
  },
  async mounted() {
    await this.init()
  },
  methods: {
    async init() {
      this.loading = true
      await this.getStoreRegion()
      this.loading = false
    },
    async getStoreRegion() {
      if (!this.amzFirstDemandCode) return
      const res = await this.$api
        .ecomAmzFirstDemandPromotionStoreRegionApi({
          amzFirstDemandCode: this.amzFirstDemandCode,
        })
        .catch(() => null)
      this.storeRegions = res?.body.data || []
      this.activeNames = this.storeRegions.map((e) => e.amazonStoreRegion)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .bottom-desc {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }
  .vxe-body--row {
    .vxe-body--column:first-child {
      background-color: #f8f8f9 !important;
    }
  }
  .el-collapse {
    border-top: none !important;
    border-bottom: none !important;
  }
  .el-collapse-item__header {
    font-size: 15px;
    font-weight: 600;
    height: 40px !important;
    line-height: 40px !important;
  }
}
.sku_main {
  font-size: 16px;
  font-weight: bold;
  color: #101010;
  height: 31px;
  line-height: 31px;
}

.bg-white {
  background-color: white !important;
}
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin-top: 3px;
}
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin: 3px 0 0 0 !important;
}
.label {
  font-weight: 600;
  color: #101010;
}
</style>
